import "./styles.scss";

const Footer = () => {
  return (
    <div className="footer">
      <p>© 2022</p>
    </div>
  );
};

export default Footer;
